export default __webpack_public_path__ + "static/media/broken-reel-1.95b19496.png";